module.exports = __webpack_public_path__ + "img/Seilbahner_2018.b990cfae.jpg";